const initState = {
	skypeLoader: false,
	purchaseLoader: false,
	complaintLoader: false,
	redirect: false,
	athleteName: [],
	myLicenses: [],
	myLicensesSubscriptions: [],
	fans: [],
	singleLicense: {},
	singleLicenseSubscriptions: {},
	licenseVerify: null,
	licenseVerifyLoader: false,
	issues: [],
	cityRequests: [],
	updateComplaintLoading: false,
	myRequests: [],
	myRequestsLastDocument: null,
	myRequestsHasMoreDocument: true,
};

const fansReducers = (state = initState, action) => {
	switch (action.type) {
		case 'GET_FANS':
			return {
				...state,
				fans: action.payload,
			};
		case 'GET_LICENSE':
			return {
				...state,
				license: action.payload,
			};
		case 'GET_ATHLETE_NAME':
			return {
				...state,
				athleteName: action.payload,
			};
		case 'GET_SINGLE_LICENSE':
			return {
				...state,
				singleLicense: action.payload,
			};
		case 'GET_SINGLE_LICENSE_SUBSCRIPTIONS':
			return {
				...state,
				singleLicenseSubscriptions: action.payload,
			};
		case 'VERIFY_LICENSE':
			return {
				...state,
				licenseVerify: action.payload,
			};
		case 'VERIFY_LICENSE_LOADER':
			return {
				...state,
				licenseVerifyLoader: action.payload,
			};
		case 'GET_MY_LICENSE':
			return {
				...state,
				myLicenses: action.payload,
			};
		case 'GET_MY_LICENSE_SUBSCRIPTIONS':
			return {
				...state,
				myLicensesSubscriptions: action.payload,
			};
		case 'GET_FAN_ISSUES':
			return {
				...state,
				issues: action.payload,
			};
		case 'GET_FAN_REQUESTS':
			return {
				...state,
				myRequests: action.payload.data,
				myRequestsHasMoreDocument: action.payload.hasMoreDocument,
				myRequestsLastDocument: action.payload.lastDocument,
			};
		case 'GET_FAN_REQUESTS_LOADMORE':
			return {
				...state,
				myRequests: [...state.myRequests, ...action.payload.data],
				myRequestsHasMoreDocument: action.payload.hasMoreDocument,
				myRequestsLastDocument: action.payload.lastDocument,
			};
		case 'FANS_REQUEST_SKYPE':
			return {
				...state,
				skypeLoader: true,
			};
		case 'FANS_REQUEST_SKYPE_END':
			return {
				...state,
				skypeLoader: false,
			};
		case 'LICENSE_PURCHASE':
			return {
				...state,
				purchaseLoader: true,
			};
		case 'LICENSE_PURCHASE_END':
			return {
				...state,
				purchaseLoader: false,
			};
		case 'REDIRECT_TRUE':
			return {
				...state,
				redirect: true,
			};
		case 'REDIRECT_FALSE':
			return {
				...state,
				redirect: false,
			};
		case 'GENERATE_COMPLAINT':
			return {
				...state,
				complaintLoader: true,
			};
		case 'GENERATE_COMPLAINT_END':
			return {
				...state,
				complaintLoader: false,
			};
		case 'GET_CITY_REQUEST':
			return {
				...state,
				cityRequests: action.payload,
			};
		case 'UPDATEComplaintLOADER':
			return {
				...state,
				updateComplaintLoading: false,
			};
		default:
			return {
				...state,
			};
	}
};
export default fansReducers;
